module.exports = __webpack_public_path__ + "static/media/ltl-package-blue.efc9d0c0.svg";